<template>
  <div v-if="showInfo" class="lp-info-overlay p" role="dialog">
    <div class="lp-info-card bc-brand p d-f fd-c g jc-c ai-c br-xl">
        <div class="d-f fd-c ai-c w-100">
        <div class="d-f jc-fe w-100">
            <button 
                class="transparent small pill icononly br-xl" 
                type="button"
                @click="closeInfo(false)">
                <IconBase icon-name="cancel" w="15" h="15" view-box="0 0 15 15">
                    <IconCancel />
                </IconBase>
            </button>
        </div>
        <p class="flex-1 tt-up">Share your profile</p>
        <p class="mute ta-c" style="max-width: 300px;">Add this URL to your social channels to attract demo submissions:</p>
        </div>

      <div 
        class="copy-url-cont d-f ai-c g br-md p-l"
        type="button"
        aria-label="Copy profile URL"
        :disabled="copying"
        @click="copyShareUrl">
        <pre class="lp-share-url m-0 flex-1" :title="shareUrl">
            {{ shareUrl }}
        </pre>

        <div class="d-f g-half p tt-up">
          <span v-show="copied">Copied</span>
          <div>
            <IconBase icon-name="copy" w="15" h="15" view-box="0 0 15 15">
                <IconCopy />
            </IconBase>
          </div>
        </div>
        <!-- <button 
        class="secondary small pill icononly br-xl" 
          type="button"
          @click="copyShareUrl"
          :disabled="copying"
          aria-label="Copy profile URL">
          <IconBase icon-name="copy" w="15" h="15" view-box="0 0 15 15">
            <IconCopy />
          </IconBase>
        </button> -->
      </div>

      <div class="d-f ai-c">
        <div class="d-f ai-c jc-c g flex-1">
            <label class="container w-auto">
                <input type="checkbox" v-model="dontShowAgain" />
                <span class="checkmark"></span>
                <span class="m-l ws-pre">Do not show this message again</span>
            </label>
            <!-- <label class="d-f ai-c">
            <input type="checkbox" v-model="dontShowAgain" /> -->
            <!-- <span class="m-l ws-pre">Do not show this message again</span> -->
            <!-- </label> -->
        </div>


      </div>

        <div class="ta-c p-b">
            <!-- <button class="secondary" @click="closeInfo(false)">Close</button> -->
            <button class="secondary" 
            @click="closeInfo(true)">
            Close</button>
        </div>
    </div>
  </div>
</template>

<script>
import IconBase from "@/assets/icons/IconBase.vue";
import IconCopy from "@/assets/icons/IconCopy.vue";
import IconCancel from "@/assets/icons/IconCancel.vue";
export default {
  name: "InfoPopup",
  components: { IconBase, IconCopy, IconCancel },
  props: {
    uid: { type: String, required: true },
    isOwnProfile: { type: Boolean, default: false },
  },
  data() {
    return {
      showInfo: false,
      dontShowAgain: false,
      copying: false,
      copied: false,
    };
  },
  computed: {
    shareUrl() {
      return `${window.location.href}`;
    },
    infoStorageKey() {
      return `labelProfileInfoDismissed:${this.uid}`;
    },
  },
  mounted() {
    if (!this.isOwnProfile) return;
    try {
      const dismissed = localStorage.getItem(this.infoStorageKey);
      this.showInfo = !dismissed;
    } catch (e) {
      this.showInfo = true;
    }
  },
  methods: {
    async copyShareUrl() {
      if (this.copying) return;
      this.copying = true;
      this.copied = false;
      const text = this.shareUrl;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          // fallback
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        this.copied = true;
        // brief visual feedback
        setTimeout(() => {
          this.copied = false;
        }, 1500);
      } catch (e) {
        console.error("copy failed", e);
        // optional: show fallback alert
        alert("Copy failed. Please select and copy the URL manually.");
      } finally {
        this.copying = false;
      }
    },

    closeInfo(confirm = false) {
      if (this.dontShowAgain) {
        try {
          localStorage.setItem(this.infoStorageKey, "1");
        } catch (e) {
          /* ignore */
        }
      }
      this.showInfo = false;
      this.$emit("closed", { confirm });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";
.lp-info-overlay {
  position: fixed;
  z-index: 1200;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}
.lp-info-card {
  max-width: 500px;
  width: 100%;
}
.copy-url-cont {
    background-color: $black;
    box-sizing: border-box;
    border: 1px solid $black;
    &:hover {
        border: 1px solid $grey;
        cursor: pointer;
    }
    .lp-share-url {
    border-radius: 4px;
    overflow-x: auto;
    margin: 0;
    font-size: 0.9rem;
    white-space: nowrap;
    max-width: 100%;
    }
}

</style>